import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import type { AddAdvanceCorrectionInvoiceRequestBody } from "../../../api/api";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import FormCheckbox from "../../components/formComponents/FormCheckbox";
import type { Currency } from "../../data/BaseEntity";
import type { SellerSelection } from "./invoiceSellerUtils";
import { AUTOMATIC_SELLER_SELECTION, buildCorrectionScopeFromSeller } from "./invoiceSellerUtils";
import InvoiceSellerSelect from "./InvoiceSellerSelect";

interface Props {
  readonly open: boolean;
  readonly orderId: string;
  readonly currency: Currency;
  readonly onClose: () => void;
  readonly onSubmit: (body: AddAdvanceCorrectionInvoiceRequestBody) => Promise<void>;
}

interface FormState {
  readonly sendByEmail: boolean;
  readonly seller: SellerSelection;
}

const CorrectionInvoiceDialog: FC<Props> = ({ open, orderId, currency, onClose, onSubmit }) => {
  const { control, handleSubmit, reset } = useForm<FormState>({
    defaultValues: { sendByEmail: true, seller: AUTOMATIC_SELLER_SELECTION },
  });

  useEffect(() => {
    if (open) {
      reset({ sendByEmail: true, seller: AUTOMATIC_SELLER_SELECTION });
    }
  }, [open, reset]);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Faktura zaliczkowa korygująca</DialogTitle>
      <DialogContent>
        <InvoiceSellerSelect
          orderId={orderId}
          currency={currency}
          invoiceKind="advance"
          control={control}
          name="seller"
        />
        <FormCheckbox name="sendByEmail" control={control} label="Wyślij mailem do klienta" />
      </DialogContent>
      <DialogActions>
        <CancelButton
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />
        <AsyncLoadingButton
          onClick={handleSubmit((s) =>
            onSubmit({ sendByEmail: s.sendByEmail, ...buildCorrectionScopeFromSeller(s.seller) }),
          )}
        >
          Utwórz
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CorrectionInvoiceDialog;
